import React from 'react';
import { TeamManagement } from '../../components/teams';

const TeamsManagement = () => {
  return <TeamManagement />;
};

export default TeamsManagement;